import { useEffect, useState } from "react";
import { Loader2, RefreshCw, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg, fdatetime } from "@/lib/api";
import { useFeature } from "@/context/AuthContext";

const Lines = ({ text }) => (
  <div className="space-y-2 text-sm text-slate-700" data-testid="stats-ai-summary-text">
    {text.split("\n").filter((l) => l.trim()).map((l, i) => {
      const t = l.replace(/^[-*]\s+/, "").replace(/^#+\s*/, "");
      const parts = t.split(/\*\*(.+?)\*\*/g);
      const action = /^azione consigliata/i.test(t);
      return (
        <p key={i} className={action ? "rounded-md bg-blue-50 px-3 py-2 text-blue-900" : "flex gap-2"}>
          {!action && <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-blue-500" />}
          <span>{parts.map((p, j) => (j % 2 ? <b key={j} className="text-slate-900">{p}</b> : p))}</span>
        </p>
      );
    })}
  </div>
);

export const StatsAiSummary = () => {
  const aiOn = useFeature("ai");
  return aiOn ? <StatsAiSummaryInner /> : null;
};

const StatsAiSummaryInner = () => {
  const [doc, setDoc] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/stats/ai-summary").then((r) => setDoc(r.data)).catch(() => setDoc({ text: null })); }, []);
  const gen = async () => {
    setBusy(true); setErr("");
    try { setDoc((await api.post("/stats/ai-summary", {}, { timeout: 120000 })).data); } catch (e) { setErr(errMsg(e)); } finally { setBusy(false); }
  };
  if (!doc) return null;
  return (
    <div className="mb-6 rounded-xl border border-blue-100 bg-gradient-to-br from-white to-blue-50/60 p-5" data-testid="stats-ai-summary">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2 font-heading text-sm font-semibold text-slate-900"><Sparkles className="h-4 w-4 text-blue-600" />Sintesi IA: 3 risultati chiave del periodo</div>
        <Button size="sm" variant={doc.text ? "outline" : "default"} disabled={busy} onClick={gen} data-testid="stats-ai-summary-button"
          className={doc.text ? "" : "bg-blue-600 hover:bg-blue-700"}>
          {busy ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : doc.text ? <RefreshCw className="mr-1.5 h-3.5 w-3.5" /> : <Sparkles className="mr-1.5 h-3.5 w-3.5" />}
          {busy ? "Analisi in corso..." : doc.text ? "Rigenera" : "Genera sintesi"}
        </Button>
      </div>
      {err && <div className="mt-3 text-sm text-rose-600" data-testid="stats-ai-summary-error">{err}</div>}
      {doc.text ? <div className="mt-4"><Lines text={doc.text} /><div className="mt-3 text-[11px] text-slate-400">Generata il {fdatetime(doc.created_at)} con i filtri attivi</div></div>
        : !busy && <p className="mt-2 text-sm text-slate-500">Premi "Genera sintesi" per far leggere all'IA i numeri del periodo filtrato.</p>}
    </div>
  );
};
